module.exports = __webpack_public_path__ + "cce4d8c1db946a0c2bcc9bdd5d6450b2.svg";